export const SET_SHIPMENTS = "SET_SHIPMENTS";
export const SET_SHIPMENTS_DATA_LOADING = "SET_SHIPMENTS_DATA_LOADING";
export const SET_SEARCH_SHIPMENTS = "SET_SEARCH_SHIPMENTS";
export const SET_SHIPMENT_FILTERS_VISIBILITY = 'SET_SHIPMENT_FILTERS_VISIBILITY';
export const SET_SEARCH_TRACKING_NO_DATA_LOADING = 'SET_SEARCH_STATUS_DATA_LOADING';
export const GET_SEARCH_TRACKING_NO = 'GET_SEARCH_STATUS';